<template>
  <div>
    <card class="" >
      <div slot="header" style="width:100%;display:block;">
      </div>
      <div slot="content" style="width:100%;display:block;">
        <CartList :list="cartProducts" :currency="$t('kol.priceUnit')" ></CartList>
      </div>
    </card>
    <div class="container text-center" v-if="cartProducts.length <1"><span class="emptyTextStyle">{{$t('cart.emptyMsg.cart')}}</span></div>
    <CartFooter class="cart-footer" :totalPrice="totalPrice" :currency="$t('kol.priceUnit')"></CartFooter>
  </div>
</template>
<script type="text/javascript">
import { FITFormCard, FITCheckbox, FITSelect, FITTextInput, FITInputTag, FITButton, MPHeader, MPFooter } from '@/components'

import AddressEntry from '../components/AddressEntry'
import CartList from '../components/CartList'
import CartFooter from '../components/CartFooter'

import { mapGetters } from 'vuex'
import { Card, Cell } from 'vux'

export default {
  name: 'Cart',
  components: {
    AddressEntry,
    CartList,
    CartFooter,
    Card,
    Cell
  },
  props: {},
  data() {
    return {

    }
  },
  created() {
    document.title = `${this.$t('kol.footer.cart')} - ${this.$t('kol.title')}`;
    this.$store.commit("hideFooter", false);
  },
  mounted() {},
  watch: {},
  computed: {
  
    totalPrice() {
      return this.$store.getters.totalPrice;
    },
    cartProducts() {
      return this.$store.state.cartProducts;
    },
    currency() {
      return this.$store.state.currency;
    }

  },
  methods: {},
}

</script>
<style type="text/css">
.cart-footer {
  overflow: hidden;
  position: fixed;
  bottom: 53px;
  width: 100%;
}

</style>



// WEBPACK FOOTER //
// src/Cart/containers/Cart.vue